import { createFileRoute, redirect } from '@tanstack/react-router'

/** Legacy URL, one hop to the State filings landing. */
export const Route = createFileRoute('/_shell/state-tax/annual-report')({
  beforeLoad: () => {
    throw redirect({ to: '/state-filings', replace: true })
  },
})
